var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [
        _vm.organizationUnitId
          ? _c("AdminNavigationV2", { attrs: { tid: _vm.organizationUnitId } })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Manage user's workspaces")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: { href: `/#/admin/organizations/users/manage/${_vm.id}` },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _vm.organizationWorkspacesLoaded && _vm.organizationWorkspacesLength == 0
        ? _c("h4", [_vm._v("No workspaces available")])
        : _vm._e(),
      _vm._v(" "),
      _vm.userNotInWorkspaces.length
        ? _c("div", { staticStyle: { "margin-bottom": "40px" } }, [
            _c("h4", { staticClass: "fg-color-blue" }, [
              _vm._v("Invite user to workspaces"),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.userNotInWorkspaces, function (w) {
                return _c(
                  "div",
                  {
                    staticClass: "col-sm-6",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _c("div", { staticClass: "card bg-light" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v(
                          "\n                            Workspace invitation\n                            "
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm pull-right",
                            on: {
                              click: function ($event) {
                                return _vm.handleAddUserToWorkspaceCommandV1(w)
                              },
                            },
                          },
                          [
                            _vm._v("\n                                Send "),
                            _c("i", {
                              staticClass: "fa fa-send-o",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("h5", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(w.Name)),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-text" }, [
                          _c("em", [_vm._v(_vm._s(w.Decription))]),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.userInWorkspaces.length
        ? _c("div", [
            _c("h4", { staticClass: "fg-color-blue" }, [
              _vm._v("User's workspaces"),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("table", { staticClass: "table table-striped table-hover" }, [
              _c(
                "tbody",
                _vm._l(_vm.userInWorkspaces, function (w) {
                  return _c("tr", [
                    _c("th", [_vm._v(_vm._s(w.Name))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(w.Decription))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-sm pull-right",
                          on: {
                            click: function ($event) {
                              return _vm.handleRemoveUserFromWorkspaceCommandV1(
                                w
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Remove an access\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }